module.exports = __webpack_public_path__ + "img/no-results.84ea666d.png";